import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Connects to data-controller="course-builder"
export default class extends Controller {
    static targets = ["chaptersList", "chapterTemplate", "emptyState"]
    static values = {
        courseId: Number,
        updatePositionUrl: String
    }

    connect() {
        console.log("Course Builder Connected 🏗️")
        this.initSortable()
        this.updateEmptyState()
    }

    initSortable() {
        if (!this.hasChaptersListTarget) return

        this.sortable = Sortable.create(this.chaptersListTarget, {
            animation: 150,
            handle: ".drag-handle",
            ghostClass: "opacity-50",
            onEnd: (evt) => this.handleReorder(evt)
        })
    }

    addChapter(event) {
        event.preventDefault()

        if (!this.hasChapterTemplateTarget) return

        const template = this.chapterTemplateTarget.content.cloneNode(true)
        const newIndex = this.chaptersListTarget.children.length + 1

        // Update the index in the template
        const container = template.querySelector("[data-chapter-card]")
        if (container) {
            container.dataset.chapterIndex = newIndex

            // Update input names with index
            template.querySelectorAll("input, textarea, select").forEach(input => {
                if (input.name) {
                    input.name = input.name.replace("NEW_INDEX", newIndex)
                }
            })
        }

        this.chaptersListTarget.appendChild(template)
        this.updateEmptyState()

        // Focus the title field
        const titleInput = this.chaptersListTarget.lastElementChild?.querySelector("input[name*='title']")
        if (titleInput) titleInput.focus()
    }

    removeChapter(event) {
        event.preventDefault()
        if (!confirm("Supprimer ce chapitre ?")) return

        const card = event.target.closest("[data-chapter-card]")
        if (!card) return

        // If persisted, mark for destruction
        const destroyInput = card.querySelector("input[name*='_destroy']")
        if (destroyInput) {
            destroyInput.value = "1"
            card.style.display = "none"
        } else {
            // New chapter, just remove
            card.remove()
        }

        this.updateEmptyState()
    }

    handleReorder(evt) {
        // Update position values
        const cards = this.chaptersListTarget.querySelectorAll("[data-chapter-card]:not([style*='display: none'])")
        cards.forEach((card, index) => {
            const positionInput = card.querySelector("input[name*='position']")
            if (positionInput) {
                positionInput.value = index + 1
            }
        })
    }

    updateEmptyState() {
        if (!this.hasEmptyStateTarget) return

        const visibleCards = this.chaptersListTarget.querySelectorAll("[data-chapter-card]:not([style*='display: none'])")

        if (visibleCards.length === 0) {
            this.emptyStateTarget.classList.remove("hidden")
        } else {
            this.emptyStateTarget.classList.add("hidden")
        }
    }

    // Expand/collapse chapter details
    toggleChapter(event) {
        const card = event.target.closest("[data-chapter-card]")
        const details = card?.querySelector("[data-chapter-details]")
        const icon = event.target.closest("button")?.querySelector("svg")

        if (details) {
            details.classList.toggle("hidden")
            icon?.classList.toggle("rotate-180")
        }
    }
}
